import { render, staticRenderFns } from "./deploy-notification.vue?vue&type=template&id=8a8f6896&lang=pug&"
import script from "./deploy-notification.vue?vue&type=script&lang=js&"
export * from "./deploy-notification.vue?vue&type=script&lang=js&"
import style0 from "./deploy-notification.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports